"use strict";

function _typeof(obj) {"@babel/helpers - typeof";return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {return typeof obj;} : function (obj) {return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}, _typeof(obj);}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.RightArrow = exports.LeftArrow = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _IconButton = _interopRequireWildcard(require("../../../IconButton"));
var _Icon = require("../../../Icon");
var _types = require("../../types");
var _sizes = _interopRequireDefault(require("./sizes"));
function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}
function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Wrapper",
  componentId: "fluffy--1xj69n3"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n"], ["\n    \n"])));
exports.Wrapper = Wrapper;
var LeftArrow = (0, _styledComponents.default)(_IconButton.default).attrs(function (_a) {
  var $direction = _a.$direction;
  return {
    icon: $direction === _types.SliderDirections.Horizontal ? _Icon.Icons.ChevronLeft : _Icon.Icons.ChevronUp,
    shape: _IconButton.IconButtonShapes.Circle
  };
}).withConfig({
  displayName: "fluffy--LeftArrow",
  componentId: "fluffy--vs2prh"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    ", ";\n\n    ", "\n"], ["\n    position: absolute;\n    ", ";\n\n    ", "\n"])), function (_a) {
  var $size = _a.$size;
  return $size ? _sizes.default[$size] : "normal";
}, function (_a) {
  var $direction = _a.$direction;
  if ($direction === _types.SliderDirections.Horizontal) {
    return (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                top: 50%;\n                left: 10px;\n                transform: translate(-0, -50%);\n            "], ["\n                top: 50%;\n                left: 10px;\n                transform: translate(-0, -50%);\n            "])));
  } else {
    return (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                top: 50%;\n                right: 10px;\n                transform: translate(-0, calc(-50% - 30px));\n            "], ["\n                top: 50%;\n                right: 10px;\n                transform: translate(-0, calc(-50% - 30px));\n            "])));
  }
});
exports.LeftArrow = LeftArrow;
var RightArrow = (0, _styledComponents.default)(_IconButton.default).attrs(function (_a) {
  var $direction = _a.$direction;
  return {
    icon: $direction === _types.SliderDirections.Horizontal ? _Icon.Icons.ChevronRight : _Icon.Icons.ChevronDown,
    shape: _IconButton.IconButtonShapes.Circle
  };
}).withConfig({
  displayName: "fluffy--RightArrow",
  componentId: "fluffy--ye5lx6"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    ", ";\n    \n    ", "\n"], ["\n    position: absolute;\n    ", ";\n    \n    ", "\n"])), function (_a) {
  var $size = _a.$size;
  return $size ? _sizes.default[$size] : "normal";
}, function (_a) {
  var $direction = _a.$direction;
  if ($direction === _types.SliderDirections.Horizontal) {
    return (0, _styledComponents.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                top: 50%;\n                right: 10px;\n                transform: translate(-0, -50%);\n            "], ["\n                top: 50%;\n                right: 10px;\n                transform: translate(-0, -50%);\n            "])));
  } else {
    return (0, _styledComponents.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                top: 50%;\n                right: 10px;\n                transform: translate(-0, calc(-50% + 30px));\n            "], ["\n                top: 50%;\n                right: 10px;\n                transform: translate(-0, calc(-50% + 30px));\n            "])));
  }
});
exports.RightArrow = RightArrow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;